import(/* webpackMode: "eager" */ "/home/janab/freelance/comverse-baseapp-next/app/loading.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/janab/freelance/comverse-baseapp-next/app/pages/Homepage.jsx");
